import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// import { NavigationBar } from '../../components';
import { Close, Open, PolicyMobile, PrivacyImg } from '../../assets/img';
import DSARForm from '../../assets/AMB DSAR-(-Data-Subject-Access-Request)FORM.pdf';
import ConsentWithdrawalForm from '../../assets/AMB Withdrawal-of-Consent-Form.pdf';
import { Link } from 'react-router-dom';
import { privacyThree, privacyFour, privacyFive } from '../../components/main';
// import { Footer } from '../../components/footer';
import { Screen } from '../../styles'

// const Navigation = NavigationBar.Navigation;
const Policy = () => {
  //   const [open, setOpen] = useState(false);
  const [policyOne, setPolicyOne] = useState(false);
  const [policyTwo, setPolicyTwo] = useState(false);
  const [policyThree, setPolicyThree] = useState(false);
  const [policyFour, setPolicyFour] = useState(false);
  const [policyFive, setPolicyFive] = useState(false);
  const [dsarOpen, setDsarOpen] = useState(false);

  const [cookiesOne, setCookiesOne] = useState(false);
  const [cookiesTwo, setCookiesTwo] = useState(false);
  const [cookiesThree, setCookiesThree] = useState(false);
  const [cookiesFour, setCookiesFour] = useState(false);
  const [cookiesFive, setCookiesFive] = useState(false);

  const togglePolicyOne = () => {
    setPolicyOne(!policyOne);
  };
  const togglePolicyTwo = () => {
    setPolicyTwo(!policyTwo);
  };
  const togglePolicyThree = () => {
    setPolicyThree(!policyThree);
  };
  const togglePolicyFour = () => {
    setPolicyFour(!policyFour);
  };
  const togglePolicyFive = () => {
    setPolicyFive(!policyFive);
  };
  const toggleDsar = () => {
    setDsarOpen(!dsarOpen);
  };

  const toggleCookiesOne = () => {
    setCookiesOne(!cookiesOne);
  };
  const toggleCookiesTwo = () => {
    setCookiesTwo(!cookiesTwo);
  };
  const toggleCookiesThree = () => {
    setCookiesThree(!cookiesThree);
  };
  const toggleCookiesFour = () => {
    setCookiesFour(!cookiesFour);
  };
  const toggleCookiesFive = () => {
    setCookiesFive(!cookiesFive);
  };

  //Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box>
      {/* nav */}
      {/* <Navigation /> */}
      {/* End of nav */}
      {/* Hero Section */}
      <Section className='hero'>
        <Container className='hero'>
          <Glass>
            <Content className='glass'>
              <h2>Privacy Policy</h2>
            </Content>
          </Glass>
        </Container>
      </Section>
      {/* End of Hero Section */}

      <Container>
        {/* Privacy Policy */}
        <Section className='policy'>
          <Header>Privacy Policy</Header>
          {/* DSAR Section */}
          <SubHeader>
            <p>Data Subject Access Request (DSAR) Procedure</p>
            <Image
              src={dsarOpen ? Close : Open}
              onClick={toggleDsar}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {dsarOpen && (
            <Content>
              <b>1. Introduction</b>
              <p style={{ paddingTop: '1rem' }}>
                The Nigeria Data Protection Act 2023 (NDPA) entitles individuals (data subjects) to request access to any personal data that <b>Abbey Bank Plc</b> holds about them. This is known as a <b>Data Subject Access Request (DSAR)</b>.
              </p>
              <p>
                This document outlines the procedures for making and responding to DSARs in compliance with the NDPA and applicable guidance issued by the Nigeria Data Protection Commission (NDPC).
              </p>
              <p>A DSAR is a request made by an individual to:</p>
              <List>
                <ListItem>Obtain a copy of their personal data held by the Bank</ListItem>
                <ListItem>Understand how their data is processed</ListItem>
                <ListItem>Know the source of the data (where applicable)</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                A request does not need to reference the NDPA or use the term "DSAR" to be valid.
              </p>

              <b>2. Submission of a DSAR</b>
              <p style={{ paddingTop: '1rem' }}>A DSAR may be made:</p>
              <List>
                <ListItem>Verbally</ListItem>
                <ListItem>By email</ListItem>
                <ListItem>In writing</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                All DSARs should be directed to the Data Protection Officer (DPO):
              </p>
              <p>
                Abbey Bank Plc<br />
                23 Karimu Kotun, Victoria Island, Lagos, Nigeria<br />
                Tel: +234 (0)2-012271695<br />
                Email: compliance@abbeybank.com<br />
                Website: www.abbeybank.com
              </p>
              <p>
                If a DSAR is made verbally, the requester may be asked to submit it in writing to ensure clarity and proper documentation.
              </p>
              <p>
                Any employee who receives a DSAR must <b>immediately escalate</b> it to the DPO without delay.
              </p>

              <FormDownloads>
                <a href={DSARForm} download='AMB_DSAR_Form.pdf'>
                  Download Data Subject Access Request (DSAR) Form
                </a>
                <a href={ConsentWithdrawalForm} download='AMB_Withdrawal_of_Consent_Form.pdf'>
                  Download Consent Withdrawal Form
                </a>
              </FormDownloads>

              <b>3. Verification of Identity</b>
              <p style={{ paddingTop: '1rem' }}>
                Before processing a DSAR, the Bank must verify the identity of the requester.
              </p>
              <p>The requester may be required to provide at least two (2) of the following:</p>
              <List>
                <ListItem>Valid international passport</ListItem>
                <ListItem>Valid driver's licence</ListItem>
                <ListItem>Recent utility bill (showing current address)</ListItem>
                <ListItem>Birth or marriage certificate</ListItem>
                <ListItem>Bank statement / mortgage statement / proof of ownership</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                If identity cannot be satisfactorily verified, the request will not be processed to prevent unauthorized disclosure.
              </p>

              <b>4. Requests Made on Behalf of a Data Subject</b>
              <p style={{ paddingTop: '1rem' }}>Where a request is submitted by a third party:</p>
              <List>
                <ListItem>Written authorization from the data subject must be provided</ListItem>
                <ListItem>Valid identification of both the requester and the data subject must be verified</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                Abbey Bank will not contact the data subject directly but will inform the requester that authorization is required.
              </p>
              <p>If authorization is unavailable, the DPO will assess:</p>
              <List>
                <ListItem>The justification for the request</ListItem>
                <ListItem>The Bank's duty of care</ListItem>
                <ListItem>Applicable NDPA provisions</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                A decision will then be made on whether disclosure is appropriate.
              </p>

              <b>5. Requests Relating to Minors</b>
              <p style={{ paddingTop: '1rem' }}>Where a parent or guardian submits a request on behalf of a minor:</p>
              <List>
                <ListItem>The Bank will assess whether the minor has sufficient understanding of their rights</ListItem>
                <ListItem>If not, the response will be provided to the parent/guardian</ListItem>
                <ListItem>If yes, the minor's consent may be required before disclosure</ListItem>
              </List>

              <b>6. Fees</b>
              <p style={{ paddingTop: '1rem' }}>DSARs are generally processed <b>free of charge</b>.</p>
              <p>However, a reasonable fee may be charged where:</p>
              <List>
                <ListItem>The request is manifestly unfounded or excessive</ListItem>
                <ListItem>The request is repetitive</ListItem>
                <ListItem>The Bank refuses to act on the request (with written justification provided)</ListItem>
              </List>

              <b>7. Processing a DSAR</b>
              <p style={{ paddingTop: '1rem' }}>Once identity and authority are confirmed, the DPO will:</p>
              <OrderedList>
                <ListItem>Log and acknowledge the request</ListItem>
                <ListItem>Assess scope and clarify where necessary</ListItem>
                <ListItem>Engage relevant departments to retrieve data</ListItem>
                <ListItem>Collate and review all relevant information</ListItem>
                <ListItem>Apply redactions where necessary</ListItem>
              </OrderedList>
              <p style={{ paddingTop: '1rem' }}>
                The Bank will take all reasonable and proportionate steps to identify and disclose all personal data relevant to the request.
              </p>
              <p><b>Third-Party Data</b></p>
              <p>Where disclosed information includes third-party data:</p>
              <List>
                <ListItem>Such data will be redacted</ListItem>
                <ListItem>If redaction is not possible and consent is not obtained, the data may be withheld</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}><b>Data Accuracy and Timing</b></p>
              <p>The response will reflect data held at the time of the request, subject to:</p>
              <List>
                <ListItem>Ongoing updates</ListItem>
                <ListItem>Routine system processing</ListItem>
              </List>

              <b>8. Response Format</b>
              <p style={{ paddingTop: '1rem' }}>
                The response will be provided in writing (email or letter) and will include:
              </p>
              <List>
                <ListItem>A copy of the personal data</ListItem>
                <ListItem>Categories of data processed</ListItem>
                <ListItem>Purpose of processing</ListItem>
                <ListItem>Data sources (where applicable)</ListItem>
                <ListItem>Recipients of the data (if any)</ListItem>
                <ListItem>Retention period (where possible)</ListItem>
                <ListItem>Explanation of any withheld data</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                All information will be presented clearly, with technical terms explained.
              </p>

              <b>9. Timeline for Response</b>
              <p style={{ paddingTop: '1rem' }}>
                Abbey Bank will respond within <b>one (1) month</b> from the latest of:
              </p>
              <List>
                <ListItem>Date the request is received</ListItem>
                <ListItem>Date identity verification is completed</ListItem>
                <ListItem>Date additional information is received</ListItem>
                <ListItem>Date payment (if applicable) is made</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}><b>Extension of Time</b></p>
              <p>The response period may be extended by up to <b>two (2) additional months</b> for:</p>
              <List>
                <ListItem>Complex requests</ListItem>
                <ListItem>Multiple requests</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>The requester will be notified within one (1) month of:</p>
              <List>
                <ListItem>The extension</ListItem>
                <ListItem>The reasons for the delay</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}><b>Holiday / Year-End Consideration</b></p>
              <p>Where requests are received during festive periods:</p>
              <List>
                <ListItem>An acknowledgment will be sent promptly</ListItem>
                <ListItem>A revised response timeline will be communicated</ListItem>
                <ListItem>Full response will be issued within one (1) month of resumption</ListItem>
              </List>

              <b>10. Refusal to Act on a Request</b>
              <p style={{ paddingTop: '1rem' }}>Abbey Bank may refuse to act on a DSAR where:</p>
              <List>
                <ListItem>The request is unfounded or excessive</ListItem>
                <ListItem>Identity cannot be verified</ListItem>
                <ListItem>Legal exemptions apply under the NDPA</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>In such cases, the requester will be informed in writing, including:</p>
              <List>
                <ListItem>Reasons for refusal</ListItem>
                <ListItem>Right to lodge a complaint with the NDPC</ListItem>
              </List>

              <b>11. Record Keeping and Accountability</b>
              <p style={{ paddingTop: '1rem' }}>The Bank will maintain records of:</p>
              <List>
                <ListItem>All DSARs received</ListItem>
                <ListItem>Actions taken</ListItem>
                <ListItem>Response timelines</ListItem>
                <ListItem>Justifications for refusals or extensions</ListItem>
              </List>
              <p style={{ paddingTop: '1rem' }}>
                This supports accountability obligations under the NDPA.
              </p>

              <b>12. Complaints and Escalation</b>
              <p style={{ paddingTop: '1rem' }}>
                All enquiries, complaints, or concerns regarding this procedure should be directed to the Data Protection Officer using the contact details above.
              </p>
              <p>
                Data subjects also have the right to lodge complaints with the <b>Nigeria Data Protection Commission (NDPC)</b> where they believe their rights have been violated.
              </p>

              <b>13. Compliance Statement</b>
              <p style={{ paddingTop: '1rem' }}>
                Abbey Bank Plc processes all Data Subject Access Requests in full compliance with the Nigeria Data Protection Act 2023 and applicable regulatory guidance issued by the Nigeria Data Protection Commission.
              </p>
            </Content>
          )}
          {/* End of DSAR Section */}

          {/* Policy */}
          <SubHeader>
            <p>Your information, what you need to know</p>
            <Image
              src={policyOne ? Close : Open}
              onClick={togglePolicyOne}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {policyOne && (
            <Content>
              <p>
                This privacy policy explains why we collect information about
                you, how that information may be used, how we keep it safe and
                confidential and what your rights are in relation to this.
              </p>
              <p>
                <TextLink to='#' color='#000'>
                  www.abbeybank.com
                </TextLink>{' '}
                is not an email service, but a corporate website. Registration
                is not required on this corporate website but is available to
                visitors interested in receiving our newsletters and email
                updates.
              </p>
              <p>
                This Online Privacy Policy explains what information we collect,
                how we collect, share, use, and protect your personal
                information when you visit or use this site and other services
                offered by Abbey Bank Plc. As an Abbey Bank
                customer, be assured that we will keep protecting your
                information as we have always done.
              </p>
              <p>
                Abbey Bank Plc customers have the opportunity to make
                choices about how their personal information may be shared, and
                we encourage you to make choices that enable us to provide you
                with quality products and services that help you meet your
                financial needs.
              </p>
            </Content>
          )}
          {/* End of Policy */}

          {/* Security */}
          <SubHeader>
            <p>Security of personal information</p>
            <Image
              src={policyTwo ? Close : Open}
              onClick={togglePolicyTwo}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {policyTwo && (
            <Content>
              <p>
                Safeguarding your personal information is our main concern. We
                maintain physical, electronic, and procedural safeguards that
                comply with applicable federal laws to secure your information
                from unauthorized access and use, accidental or unlawful
                alteration and destruction, and other unlawful or unauthorized
                forms of processing. We engage in the continuous training of our
                employees in the proper management of personal information. When
                we use other companies to provide services, we require them to
                protect the confidentiality of personal information they
                receive.
              </p>
              <p>
                <b>At Abbey Bank Plc</b>, we take data privacy very
                seriously and we provide our customers with all necessary data
                security to protect such personal information from unauthorized
                access. We require any third parties who carry out any work on
                our behalf to comply with appropriate compliance standards to
                protect your information. We are pleased to announce that we
                comply with global best practices and requirements of Nigeria
                Data Protection Regulation (NDPR).
              </p>
            </Content>
          )}
          {/* End of Security */}

          {/* Information we collect */}
          <SubHeader>
            <p>The information we collect</p>
            <Image
              src={policyThree ? Close : Open}
              onClick={togglePolicyThree}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {policyThree && (
            <Content className='third'>
              <p>
                Abbey Bank Plc will only collect your information in
                line with relevant regulations and laws.
              </p>
              <b>How do we collect information?</b>
              <p style={{ paddingTop: '2rem' }}>
                We may collect information from a range of sources, and it may
                relate to any of our products or services we currently provide
                or may have provided in the past.
                <br /> We collect your personal information when,
              </p>
              <List>
                {privacyThree.map(({ item }) => (
                  <ListItem key={item}>{item}</ListItem>
                ))}
              </List>
              <p style={{ paddingTop: '2rem' }}>
                Note that we may collect information about your computer (or
                mobile device), including where available your IP address,
                operating system, and browser type, for system administration or
                for our own commercial purposes. This is statistical data about
                our users' browsing actions and patterns and does not identify
                any individual.
              </p>
            </Content>
          )}
          {/* End of Information we collect */}

          {/* How we use information */}
          <SubHeader>
            <p>How we use your information?</p>
            <Image
              src={policyFour ? Close : Open}
              onClick={togglePolicyFour}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {policyFour && (
            <Content>
              <List>
                {privacyFour.map(({ item }) => (
                  <ListItem key={item}>{item}</ListItem>
                ))}
              </List>
            </Content>
          )}
          {/* End of how we use information */}

          {/* Who we share information with */}
          <SubHeader>
            <p>Who we share information with?</p>
            <Image
              src={policyFive ? Close : Open}
              onClick={togglePolicyFive}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {policyFive && (
            <Content>
              <p>
                The Bank, (Abbey Bank Plc) in efforts to provide you
                with excellent products and services may need to outsource its
                product delivery, this will be done in line with relevant
                regulations and law. We may share your informaion in order to
                provide you with products and services you have requested.
                <br />
                We may also share your information where we have a public or
                legal duty to do so, when we need it to conclude regulatory
                reporting and when we have requested and received your
                permission to share it.
                <br />
                Individual rights
              </p>
              <NewList>
                {privacyFive.map(({ header, content }) => (
                  <div key={header} style={{ paddingBottom: '1.5rem' }}>
                    <h4>{header}</h4>
                    <NewListItem>{content}</NewListItem>
                  </div>
                ))}
              </NewList>
            </Content>
          )}
          {/* End of who we share information with */}

          <Header pt='3rem' id='cookies'>Cookies Policy</Header>

          {/* use of cookies */}
          <SubHeader>
            <p>Our Use Of Cookies</p>
            <Image
              src={cookiesOne ? Close : Open}
              onClick={toggleCookiesOne}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {cookiesOne && (
            <Content>
              <p>
                We use cookies on our websites (our website, or our websites)
                for a number of purposes. They help us provide you with a good
                experience when you browse our website and allow us to improve
                our site. By continuing to browse our website, you are agreeing
                to our use of cookies.
              </p>
              <p>
                This Cookies Policy (Policy) explains how we use cookies and the
                choices you have. Except as otherwise stated in this Policy, our
                Privacy Policy will apply to our processing of data that we
                collect via cookies.
              </p>
              <p>
                By using our website (by clicking, navigating, or scrolling),
                you are consenting to our use of cookies in accordance with this
                Policy. If you do not agree to our use of cookies, you can
                prevent the installation of cookies through the settings of your
                browser or not use our website at all. However, if you disable
                the use of cookies, this might cause some parts of this website
                not to function properly for you and it may impact your user
                experience on this site.
              </p>
            </Content>
          )}
          {/* End of use of cookies */}
          {/* What are cookies */}
          <SubHeader>
            <p>What are cookies?</p>
            <Image
              src={cookiesTwo ? Close : Open}
              onClick={toggleCookiesTwo}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {cookiesTwo && (
            <Content>
              <p>
                Cookies are messages or small files that are placed on your web
                browser when you visit an internet site. Cookies are useful and
                do a lot of different things, including allowing a website to
                recognize a user's device, improving online experience etc.
              </p>
            </Content>
          )}
          {/* End of what are cookies */}
          {/* Why we use cookies */}
          <SubHeader>
            <p>How and why we use cookies?</p>
            <Image
              src={cookiesThree ? Close : Open}
              onClick={toggleCookiesThree}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {cookiesThree && (
            <Content>
              <p>
                We use cookies when you access our websites and our online
                products and services to make the site work better and to help
                us understand how you use our site. Cookies enable us to offer
                tailored products and to understand the information we receive
                about you, including information about your use of other
                websites and apps, whether or not you have an account with us.{' '}
                <br />
                Cookies help us provide, protect, and improve our products and
                services, by personalizing, tailoring, and measuring the
                services and products we provide for satisfactory and safe
                experience. We also use them to help authentication of user,
                assess performance and functionality of our online products and
                services, and analytical research.
              </p>
            </Content>
          )}
          {/* End of why we use cookies */}
          {/* Individual responsibility */}
          <SubHeader>
            <p>Individual Responsibility</p>
            <Image
              src={cookiesFour ? Close : Open}
              onClick={toggleCookiesFour}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {cookiesFour && (
            <Content>
              <p>
                Individuals are responsible for making sure the information
                provided to the Bank is accurate and should inform the Bank on
                any changes as it occurs, this will enable us to update your
                information with us.
              </p>
              <p>
                If you would like further information on anything included in
                this Privacy Policy, contact us at 23,{' '}
                <b>Karimu Kotun Street, Victoria Island, Lagos,</b>
                <br />
                <TextLink to='#' color='#0867BE'>
                  dataprotectionofficer@abbeybank.com
                </TextLink>
              </p>
            </Content>
          )}
          {/* End of individual responsibility */}

          {/* Changes to policy */}
          <SubHeader>
            <p>Changes to the Policy</p>
            <Image
              src={cookiesFive ? Close : Open}
              onClick={toggleCookiesFive}
              alt='icon'
              className='icon'
            />
          </SubHeader>
          {cookiesFive && (
            <Content>
              <p>
                This Privacy policy may be updated from time to time and the
                most recent version can be found on{' '}
                <TextLink to='#' color='#0867BE'>
                  www.abbeybank.com
                </TextLink>
              </p>
            </Content>
          )}
          {/* End of changes to policy */}
        </Section>
      </Container>

      {/* footer */}
      {/* <Footer /> */}
      {/* End of Footer */}
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
  // background-color: #fff;
`;
const Container = styled.div`
  width: 70%;
  margin: 10rem auto 0;
  ${Screen.miniLargeScreen`
  width: 90%;
  margin: 5rem auto;
  `}
  ${Screen.pad`
  width: 90%;
  margin: 6rem auto 0;
  `}
  ${Screen.mediumpc`
  width: 90%;
  margin: 3rem auto;
  `}
  ${Screen.smallpc`
  width: 90%;
  `}
${Screen.tablet`
  width: 90%;
  margin: 0 auto!important;
  `}
  ${Screen.surfaceDuo`
  width: 70%;
  margin: 0 auto!important;
  `}
  ${Screen.mediumPhone`
  width: 70%;
  margin: 0 auto!important;
  `}
  ${Screen.phone`
  width: 70%;
  margin: 0 auto!important;
  `}
  ${Screen.smallPhone`
  width: 80%;
  margin: 0 auto!important;
  `}
   ${Screen.galaxyFold`
  width: 85%;
  margin: 0 auto!important;
  `}
  &.hero {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    width: 85%;
    ${Screen.miniLargeScreen`
    padding-top: 5rem;
    `}
    ${Screen.pad`
    padding-top: 0;
    `}
    ${Screen.mediumpc`
    padding-top: 5rem;
    `}
     ${Screen.smallpc`
    padding-top: 0;
    `}
    ${Screen.tablet`
    padding-top: 3rem;
    `}
    ${Screen.mediumPhone`
    width: 100%;
    margin: 0!important;
    padding-top: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    `}
    ${Screen.phone`
    width: 100%;
    margin: 0!important;
    display: flex;
    justify-content: center;
    align-items: center;
    `}
    ${Screen.smallPhone`
    width: 100%;
    margin: 0!important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 3rem
    `}
  }

  p {
    font-size: 1.2rem;
  }
`;

const Image = styled.img`
  &.policy {
    margin: 3rem 0;
  }

  &.icon {
    cursor: pointer;
    ${Screen.mediumPhone`
    width: 24px;
    height: 24px;
    `}
    ${Screen.phone`
    width: 22px;
    height: 22px;
    `}
    ${Screen.smallPhone`
    width: 20px;
    height: 20px;
    `}
  }
`;
const Glass = styled.div`
  width: 540px;
  height: 130px;
  background: rgba(255, 255, 255, 0.7);
  ${Screen.pad`
  margin-top: 2rem;
  `}
   ${Screen.mediumpc`
  margin-top: 0;
  `}
  ${Screen.smallpc`
  background: rgba(255, 255, 255, 0);
  `}
`;
const Section = styled.section`
  width: 100%;
  &.hero {
    min-height: 50vh;
    background-image: url(${PrivacyImg});
    background-position: center;
    background-size: cover;
    margin-top: 80px;
    padding-top: 7rem;
    ${Screen.miniLargeScreen`
    padding-top: 5rem
    `}
    ${Screen.pad`
    padding-top: 5rem;
    min-height: 60vh;
    `}
    ${Screen.mediumpc`
    min-height: 30vh!important;
    padding-top: 4rem
    `}
    ${Screen.smallpc`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 1rem;
    `}
     ${Screen.tablet`
    min-height: 40vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
     ${Screen.surfaceDuo`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.mediumPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.phone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.smallPhone`
    min-height: 30vh;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
  }
  &.policy {
    margin: 5rem 0;
    min-height: 100vh;
    padding: 0 7rem;
    ${Screen.mediumpc`
    min-height: 50vh;
    `}
    ${Screen.smallpc`
    min-height: 60vh;
    `}
    ${Screen.surfaceDuo`
    padding: 0;
    min-height: 60vh;
    `}
    ${Screen.mediumPhone`
    padding: 0;
    margin-top: 3rem;
    min-height: 60vh;
    `}
    ${Screen.phone`
    padding: 0;
    margin-top: 3rem;
    min-height: 70vh;
    `}
    ${Screen.smallPhone`
    padding: 0;
    margin-top: 3rem;
    min-height: 70vh;
    `}
  }
`;
const Header = styled.header`
  font-size: 3rem;
  color: #002668;
  font-weight: bold;
  padding-bottom: 1.5rem;
  padding-top: ${({ pt }) => pt};
  ${Screen.mediumPhone`
  text-align: center;
  font-size: 24px;
  text-transform: uppercase;
  `}
  ${Screen.phone`
  text-align: center;
  font-size: 22px
  `}
  ${Screen.smallPhone`
  text-align: center;
  font-size: 22px
  `}
`;
const SubHeader = styled.div`
  display: flex;
  margin-bottom: 1rem;
  p {
    font-size: 1.2rem;
    font-weight: bold;
    color: #c81e19;
    padding-right: 1rem;
    ${Screen.mediumPhone`
    font-size: 16px;
    padding-right: 0
    `}
    ${Screen.phone`
    font-size: 14px;
    padding-right: 0
    `}
    ${Screen.smallPhone`
    font-size: 14px;
    padding-right: 0
    `}
  }
`;
const Content = styled.div`
  &.glass {
    padding: 3rem;
    h2 {
      font-size: 45px;
      color: #002668;
      text-shadow: 5px 3px 5px #666;
      text-transform: uppercase;
      ${Screen.smallpc`
      padding-left: 5rem;
      padding-top: 12rem;
      font-size: 35px;
      `}
      ${Screen.tablet`
      padding-left: 5rem;
      padding-top: 4rem;
      font-size: 35px;
      `}
      ${Screen.surfaceDuo`
      padding-left: 4rem;
      padding-top: 1rem;
      font-size: 35px;
      font-size: 24px;
      `}
      ${Screen.mediumPhone`
      font-size: 24px;
      padding-left: 3rem;
      padding-top: 0;
      `}
      ${Screen.phone`
      font-size: 24px;
      padding-left: 2rem;
      padding-top: 0;
      `}
      ${Screen.smallPhone`
      font-size: 24px;
      padding: 0;
      `}
      ${Screen.galaxyFold`
      font-size: 20px;
      `}
    }
  }
  p {
    padding-bottom: 2rem;
    font-size: 1.05rem;
    word-spacing: 0.1rem;
    ${Screen.mediumPhone`
    font-size: 14px!important;
    padding-bottom: 1rem!important;
    word-spacing: 0;
    `}
    ${Screen.phone`
    font-size: 14px!important;
    padding-bottom: 1rem!important;
    word-spacing: 0;
    `}
  ${Screen.smallPhone`
    font-size: 13px!important;
    padding-bottom: 1rem!important;
    word-spacing: 0;
    `}

    &:last-child {
      padding-bottom: 2rem;
    }
  }

  b {
    ${Screen.mediumPhone`
    font-size: 13px!important
    `}
    ${Screen.phone`
    font-size: 13px!important
    `}
    ${Screen.smallPhone`
    font-size: 13px!important
    `}
  }
`;
const TextLink = styled(Link)`
  color: ${({ color }) => color};
  ${Screen.mediumPhone`
  word-break: break-all
  `}
  ${Screen.phone`
  word-break: break-all
  `}
  ${Screen.smallPhone`
  word-break: break-all
  `}
`;
const OrderedList = styled.ol`
  list-style-type: decimal;
  padding-left: 1.5rem;
  font-size: 1rem;
`;
const List = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
  font-size: 1rem;
`;
const NewList = styled(List)`
  list-style-type: none;
  ${Screen.mediumPhone`
    h4 {
      font-size: 14px!important;
    }
  `}
  ${Screen.phone`
    h4 {
      font-size: 14px!important;
    }
  `}
  ${Screen.smallPhone`
    h4 {
      font-size: 13px!important;
    }
  `}
`;
const ListItem = styled.li`
  padding-top: 0.5rem;
  ${Screen.mediumPhone`
  font-size: 14px!important
  `}
  ${Screen.phone`
  font-size: 14px!important
  `}
  ${Screen.smallPhone`
  font-size: 13px!important
  `}
  &:last-child {
    padding-bottom: 2rem
  }
`;
const NewListItem = styled.li`
  padding-top: 0.3rem;
  ${Screen.mediumPhone`
  font-size: 13px!important;
  padding-bottom: 0!important;
  `}
  ${Screen.phone`
  font-size: 13px!important;
  padding-bottom: 0!important;
  `}
  ${Screen.smallPhone`
  font-size: 13px!important;
  padding-bottom: 0!important;
  `}
  &:last-child {
    padding-bottom: 2rem
  }
`;
const FormDownloads = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 2rem;
  a {
    display: inline-block;
    color: #0867BE;
    font-weight: bold;
    font-size: 1rem;
    text-decoration: underline;
    &:hover {
      color: #002668;
    }
  }
`;
export default Policy;
